import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';
import _startCase from 'lodash/startCase';
import moment from 'moment';

const messages = defineMessages({
  selectReport: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.selectReport',
    defaultMessage: 'Select Report',
  },
  notSet: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.notSet',
    defaultMessage: 'Not Set',
  },
  date: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.date',
    defaultMessage: '{date, date, ::MM dd YYYY}',
  },
});

export const CarePlanSelector = ({
  carePlans,
  activeCarePlanId,
  onChangeCarePlan,
  disabled,
}: {
  activeCarePlanId: string;
  carePlans: fhir.CarePlan[];
  onChangeCarePlan: (carePlanId: string) => void;
  disabled?: boolean;
}) => {
  const { formatMessage } = useIntl();

  const onChange = (carePlanId: string) => {
    onChangeCarePlan(carePlanId);
  };

  return (
    <Select
      label={formatMessage(messages.selectReport)}
      onChange={onChange}
      disabled={disabled}
      value={activeCarePlanId}
      fullWidth
    >
      {carePlans.map(carePlan => {
        const start = carePlan.period?.start
          ? formatMessage(messages.date, {
              date: moment(carePlan.period.start).toDate(),
            })
          : formatMessage(messages.notSet);
        const end = carePlan.period?.end
          ? formatMessage(messages.date, {
              date: moment(carePlan.period.end).toDate(),
            })
          : formatMessage(messages.notSet);
        return (
          <SelectOption
            key={carePlan.id}
            value={carePlan.id!}
            title={_startCase(carePlan.status)}
            subtitle={`${start} - ${end}`}
          />
        );
      })}
    </Select>
  );
};
